export const ASSESSMENT_ANSWERS_QUERY = '/assessment/answers';
export const NEW_IN_SCOPE_DOMAINS_QUERY = '/quick-answer/new-in-scope-domains';
export const REASSESMENT_STATUS_QUERY = '/reassessment/status';
